module.exports = __webpack_public_path__ + "19051d2a408ee59ffb37a811de36fdd7.svg";